export const REDUCER_KEY = 'account';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';